/**
 * Public Google Maps HTTP endpoints (not secrets). Keys stay in env via {@link CONSTANTS}.
 * @see https://developers.google.com/maps/documentation/embed/embedding-map
 * @see https://developers.google.com/maps/documentation/maps-static/overview
 */
export const GOOGLE_MAPS_EMBED_V1_PLACE_BASE_URL =
  'https://www.google.com/maps/embed/v1/place'

export const GOOGLE_MAPS_STATIC_MAP_BASE_URL =
  'https://maps.googleapis.com/maps/api/staticmap'
